import React from 'react';
import { ToolbarSwitch } from './ListViewToolbar/ListViewToolbar.style';

interface ListViewPastBookingsToggleProps {
  /* What the switch shows: whether past bookings are being left out */
  hidePastBookings: boolean;
  onHidePastBookingsChange: (hidePastBookings: boolean) => void;
  /** False for any day but today, where hiding does not apply */
  canHidePastBookings?: boolean;
}

/**
 * Whether the bookings that have already ended are left out of the list, so
 * the day in progress shows what is still to come.
 *
 * What it flips is a preference that is remembered (see useViewSettings) and
 * applies on today only; whether it applies is ListView's to work out, and
 * this switch draws the answer it is handed. On any other day it is therefore
 * shown off and disabled rather than taken away, with a tooltip saying why.
 *
 * The label names the state, not the action, unlike the sets toggle beside
 * it: "Show past bookings" on a switch that is on would read as the opposite
 * of what the list is doing.
 */
const ListViewPastBookingsToggle = ({
  hidePastBookings,
  onHidePastBookingsChange,
  canHidePastBookings = true
}: ListViewPastBookingsToggleProps) => (
  /* The title is on the wrapper: a disabled control takes no pointer events,
     so a tooltip on the switch itself would never show */
  <div
    title={canHidePastBookings ? undefined : i18n('Past bookings are only hidden on today')}
    data-test-list-view-past-bookings-toggle
  >
    <ToolbarSwitch
      variant="switch"
      label={i18n('Hide past bookings')}
      defaultChecked={hidePastBookings}
      disabled={!canHidePastBookings}
      onChange={() => onHidePastBookingsChange(!hidePastBookings)}
    />
  </div>
);

export default ListViewPastBookingsToggle;
